/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { LoginNavigationSkeleton } from "@/types/contentful/login/login-navigation";
import { Entry } from "contentful";

export const useLoginNavigation = () => useQuery<Entry<LoginNavigationSkeleton>>({
    queryKey: ["loginNavigation"],
    queryFn: async (): Promise<Entry<LoginNavigationSkeleton>> => {
      const response = await fetch("/api/contentful/login");
      if (!response.ok) throw new Error("Failed to fetch login navigation");

      const data: Entry<LoginNavigationSkeleton> = await response.json();
      return data;
    },
    staleTime: 1000 * 60 * 60 * 24, // Keep fresh for 24 hours
    retry: 1 // Retry once on failure
  });
